import { Helmet } from 'react-helmet-async';
import NavBar from '@/components/NavBar';
import MainFooter from '@/components/MainFooter';
import HeroSection from '@/pages/hire-at-149/HeroSection';
import ComparisonTable from '@/pages/hire-at-149/ComparisonTable';
import NotRightSection from '@/pages/hire-at-149/NotRightSection';
import FAQSection from '@/pages/hire-at-149/FAQSection';
import FinalCTA from '@/pages/hire-at-149/FinalCTA';

const HireAt149 = () => {
  return (
    <div className="min-h-screen bg-background">
      <Helmet>
        <title>Hire at ₹149 - Cutshort Starter Plan</title>
        <meta name="description" content="Unlock Cutshort Starter plan at ₹149. Limited time launch offer." />
      </Helmet>
      <NavBar />
      <main className="pt-20">
        <div className="bg-yellow-400 text-gray-900 py-3 px-4 text-center">
          <div className="container mx-auto flex items-center justify-center gap-2">
            <span className="font-bold text-sm">
              Grab the limited period offer on the Starter plan before prices are revised
            </span>
          </div>
        </div>
        <HeroSection />
        <ComparisonTable />
        <NotRightSection />
        <FAQSection />
        <FinalCTA />
      </main>
      
      <MainFooter />
    </div>
  );
};

export default HireAt149;


